import { Button } from "../ui/Button";

interface SkillEditBannerProps {
  slug: string;
  name: string;
  onApply: () => void;
  applying: boolean;
  applied: boolean;
}

export function SkillEditBanner({ slug, name, onApply, applying, applied }: SkillEditBannerProps) {
  return (
    <div className="mt-2 rounded-md border border-indigo-200 bg-indigo-50 p-2">
      <div className="flex items-center justify-between gap-2">
        <div className="min-w-0">
          <p className="text-xs font-medium text-indigo-700">
            Suggested edit: {name}
          </p>
          <p className="text-xs text-indigo-500">{slug}</p>
        </div>
        {applied ? (
          <span className="shrink-0 text-xs font-medium text-green-600">Applied</span>
        ) : (
          <Button
            variant="primary"
            size="sm"
            onClick={onApply}
            loading={applying}
          >
            Apply
          </Button>
        )}
      </div>
    </div>
  );
}
